<template>
  <div
    class="add-melody-file-container"
    :class="{
      [`add-melody-file-container--${createRenderType}`]: true,
      [`add-melody-file-container--cn`]: globalConfig.appname == chinaAppName,
    }"
  >
    <file-pond
      ref="refUpload"
      v-if="renderData.ifRenderFilePond"
      label-idle="歌曲文件"
      v-bind:allow-multiple="false"
      :acceptedFileTypes="renderData.acceptedFileTypes.join(',')"
      @handleAfterRead="handleAfterRead"
      @addfile="handleAddFile"
      v-bind:files="renderData.files"
    >
    </file-pond>
    <div class="add-melody-file-main" ref="refUploadContent">
      <!-- <div class="add-melody-new-corner-mark">
        <span class="block">{{ $$t("common.new") }}</span>
      </div> -->

      <div class="add-melody-file-selectfile pointer">
        <i class="block"></i>
        <span class="block">{{ $$t("create.song_file") }}</span>
        <label class="vip_plan" v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'">
          {{ $$t("create.pro_plan") }}
        </label>
      </div>
      <div class="add-melody-file-desc">
        {{ $$t("create.add_melody_file_desc") }}
      </div>
    </div>
    <div
      class="add-music-reference-edit-mask pointer"
      @click="
        (e) => {
          showSubscribeDialog();
          // goSubscribe(2, 'motif_local_upload');
        }
      "
      v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
    ></div>
  </div>
  <EditRecordClip
    :editFileName="renderData.editFileName"
    v-model:visible="renderData.editFilePopupVisible"
    v-if="renderData.editFilePopupVisible"
    :clipSourceData="renderData.clipSourceData"
    @complete="handleEditFileCompleted"
  >
  </EditRecordClip>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

import ElementUpload from "@/components/basic/upload/elementUpload.jsx";
import tools from "@/utils/tools.js";
import Button from "@/components/basic/button/Button.vue";
import IconButton from "@/components/basic/button/IconButton.vue";
import EditRecordClip from "./editRecordClip.vue";

import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import message from "@/components/functionCallComponent/message.jsx";
import clipUtil from "@/components/media/utils/clipUtil.js";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import axios from "axios";

import apiReferMusic from "@/api/api/apiReferMusic.js";
import apiCommon from "@/api/api/apiCommon.js";
import userReferMusicStore from "@/store/create/motifDataStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";
import { storeToRefs } from "pinia";
import midiUtils from "@/components/media/utils/midiUtils.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const referMusicStore = userReferMusicStore();
const draftDataStore = useDraftDataStore();
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
// Create component
const FilePond = vueFilePond();
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const refUploadContent = ref(null);
const refUpload = ref(null);
const refInput = ref(null);
const props = defineProps({});
const emits = defineEmits(["saveSuccess"]);
const acceptedFileTypes = [
  "audio/x-wav",
  "video/quicktime",
  "video/mp4",
  "audio/wav",
  "audio/x-m4a",
  "audio/flac",
  "audio/mpeg",
  ".mp3",
  ".wav",
  ".m4a",
  ".mp4",
  ".mov",
  ".MP4",
  ".flac",
  ...(ModuleOpenStateControl.create.motifReferCustomMidi
    ? [".MIDI", ".midi", ".mid", ".MID", "audio/midi"]
    : []),
];
const renderData = reactive({
  ifRenderFilePond: true,
  files: [],
  file: null,
  acceptedFileTypes: acceptedFileTypes,
  editFilePopupVisible: false,
  clipSourceData: null,
  editFileName: "",
});

const checkMediaType = (file) => {
  if (file.type.toLocaleLowerCase().startsWith("audio")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "audio"
      : "unknown";
  } else if (file.type.toLocaleLowerCase().startsWith("video")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "video"
      : "unknown";
  } else {
    return "unknown";
  }
};

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation();
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    });
  }
};

const showSubscribeDialog = () => {
  emits("showSubscribeDialog", "reference", {
    membership_source1: "membership_feature",
    membership_source2: "motif_local_upload",
  });
};

const initUploadContent = () => {
  if (refUploadContent.value) {
    nextTick(() => {
      refUpload.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContent.value);
    });
    setTimeout(() => {
      refUpload.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", renderData.acceptedFileTypes.join(","));
    }, 20);
  }
};

const handleSelectFile = () => {
  refUpload.value?.$el.querySelector(".filepond--drop-label").click();
};
const handleAddFile = (error, fileItem, fileList) => {
  if (error) {
    console.error("File add error:", error);
    return;
  }
  console.log("File added:", fileItem);

  handleAfterRead(fileItem.file, 2).then(async () => {
    if (
      tools.isMidiFile(renderData.file) &&
      ModuleOpenStateControl.speControl.motifReferMidiPlay
    ) {
      const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
        renderData.file,
        (obj) => {
          renderData.uploadCallbackData = obj;
        }
      );
      const saveData = {
        url: objectStorageRes.pathKey,
        duration_milliseconds: Math.ceil(renderData.duration * 1000),
        // feed_id: draftDataStore.feed_id,
        source_type: 2,
        title: renderData.file.name.replace(/.[a-zA-Z0-9]+$/, ""),
        bpm: 0,
      };
      saveMotif(saveData);
    } else {
      doInitEditFile();
    }
    //doInitEditFile();
    //saveRecordFile(renderData.file);
  });
};

const handleAfterRead = (e, type = 1) => {
  return new Promise(async (resolve, reject) => {
    let fileType = checkMediaType(e);
    if (fileType == "unknown") {
      message.info({
        position: "top",
        content: $$t("create.select_audio_or_video"),
      });
      reject("not audio");
      return;
    }
    console.log("File handleAfterRead:", type, e);
    let file = null;
    let blobUrl = "";
    if (e instanceof File) {
      file = e;
    } else {
      if (e.target.files && e.target.files.length > 0) {
        file = e.target.files[0];
      }
      renderData.ifRenderFilePond = false;
      renderData.files = [];
    }
    renderData.fileTemp = file;
    nextTick(() => {
      renderData.ifRenderFilePond = true;
      nextTick(() => {
        initUploadContent();
      });
    });
    if (!file) return;
    if (file.size > 1024 * 1024 * 100) {
      message.info({
        position: "top",
        content: $$t("create.max_file_size"),
      });
      reject("max file size");
      return;
    }
    const closeMsg = message.loading({
      content: $$t("create.extract_song"),
    });
    try {
      let duration = 0;
      if (tools.isMidiFile(file)) {
        file = await transMidiToMp3(file);
        duration = await tools.getMediaFileDuration(file);
        if (duration <= 0) {
          closeMsg.clear();
          message.info({
            position: "top",
            content: $$t("create.motif_min_time_tip"),
          });
          reject("min file duration");
          return;
        } else {
          renderData.duration = duration;
          renderData.file = file;
          resolve();
          closeMsg.clear();
          return;
        }
        // try {
        //   const midiFileRes = await midiUtils.convertMidiFileToMp3(file);
        //   file = midiFileRes.file;
        // } catch (e) {
        // }
      } else {
        duration = await tools.getMediaFileDuration(file);
      }

      closeMsg.clear();
      if (duration > 0) {
        if (duration < 5) {
          message.info({
            position: "top",
            content: $$t("create.motif_min_time_tip"),
          });
          reject("min file duration");
        } else {
          renderData.duration = duration;
          renderData.file = file;
          resolve();
        }
      } else {
        console.log("getMediaFileDuration", duration, file?.name, file?.type);
        message.info({
          position: "top",
          content: $$t("create.select_audio_or_video"),
        });
        reject("not audio");
        return;
      }
    } catch (e) {
      if (file.type == "audio/midi") {
        message.info({
          position: "top",
          content: $$t("create.select_audio_or_video"),
        });
        return;
      }
      try {
        const outputfile = await ffmpegUtil.transFileToMp3(file);
        let duration = 0;
        if (outputfile) {
          duration = await tools.getMediaFileDuration(outputfile.file);
        }
        closeMsg.clear();
        if (duration > 0) {
          if (duration < 5) {
            message.info({
              position: "top",
              content: $$t("create.motif_min_time_tip"),
            });
            reject("min file duration");
          } else {
            renderData.duration = duration;
            renderData.file = outputfile.file;
            resolve();
          }
        } else {
          console.log(
            "transFileToMp3 getMediaFileDuration",
            duration,
            file?.name,
            file?.type
          );
          message.info({
            position: "top",
            content: $$t("create.select_audio_or_video"),
          });
          reject("not audio");
          return;
        }
      } catch (e) {
        closeMsg.clear();
        console.log("not audio", e, file?.name, file?.type);
        message.info({
          position: "top",
          content:
            fileType == "video"
              ? $$t("create.select_video_error")
              : $$t("create.select_audio_error"),
        });
        reject("not audio");
      }
    }
  });
};

const doDownloadFile = async (url, filename) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = new Blob([this.response], {
          type: this.response?.type || "text/plain",
        });
        const resfile = new File([blob], filename, { type: blob.type });
        resolve(resfile);
      } else {
        reject(this.statusText);
      }
    };
    xhr.send();
  });
};
const transMidiToMp3 = (file) => {
  return new Promise(async (resolve, reject) => {
    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      file
    );
    const saveData = {
      midi_url: objectStorageRes.pathKey,
    };
    apiCommon
      .transMidiToMp3(saveData)
      .then((res) => {
        if (res.code == 200) {
          doDownloadFile(
            getObjectStorageFullUrl(res.data?.mp3_url),
            (res.data?.name ?? "audio_from_youtue").replace(/\s+/, "_") +
              "." +
              tools.getFileExtension(res.data?.mp3_url ?? ".mp3")
          )
            .then((resFile) => {
              resolve(resFile);
            })
            .catch((e) => {
              reject(e);
            });
        } else {
          reject(res.message);
        }
      })
      .catch((e) => {
        console.error("transMidiToMp3", e);
        reject(e);
      });
  });
};

const doInitEditFile = async (filep) => {
  let file = renderData.file ?? filep;

  if (tools.isMidiFile(renderData.fileTemp)) {
    renderData.editFileName = renderData.fileTemp?.name
      ?.replace(/.[a-zA-Z0-9]+$/, "")
      ?.slice(0, 60);
  } else {
    renderData.editFileName = (
      file?.name?.replace(/.[a-zA-Z0-9]+$/, "") ?? ""
    )?.slice(0, 60);
  }
  console.log("doInitEditFile", file.type, file);
  window.curSelectFile = file;
  const closeMsg = message.loading({
    content: $$t("create.extract_song"),
  });
  let decodeData = null;
  let blobUrl = null;
  let duration = 0;
  try {
    decodeData = await clipUtil.getDecodeDataByFile(file);
    duration = decodeData.duration;
    blobUrl = (window.URL || window.webkitURL).createObjectURL(file);
  } catch (e) {
    try {
      console.log("name:", file.name, "type:", file.type, "size:", file.size);
      const outputfile = await ffmpegUtil.transFileToMp3(file);
      file = outputfile.file;
      blobUrl = outputfile.blobUrl;
      decodeData = await clipUtil.getDecodeDataByFile(file);
      duration = decodeData.duration;
    } catch (e) {
      console.error("handleAfterReaderr", e);
      closeMsg.clear();
      message.info({
        content: $$t("create.extract_song_failed"),
      });
      return;
    }
  }

  console.log("renderEditFile", renderData.clipSourceData);
  closeMsg.clear();
  renderData.editFilePopupVisible = true;
  nextTick().then(() => {
    renderData.clipSourceData = {
      duration: duration,
      isUpload: true,
      blobUrl: blobUrl,
      url: null,
      type: "audio/wav",
      decodeData,
    };
  });
};

const saveRecordFile = async (file) => {
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  });
  let saveData = {};
  const fileSaveData = {
    filename: file.name.replace(/.[0-9a-zA-Z]+$/, ""),
  };
  try {
    if (file.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(file);
        fileSaveData.url = transfile.blobUrl;
        fileSaveData.blob = transfile.blob;
        fileSaveData.file = transfile.file;
      } catch (e) {
        console.error("transFileToMp3 error", e);
      }
    }

    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      fileSaveData.file,
      (obj) => {
        renderData.uploadCallbackData = obj;
      }
    );
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(renderData.duration * 1000),
      // feed_id: draftDataStore.feed_id,
      source_type: 2,
      title: fileSaveData.filename,
      bpm: 0,
    };
  } catch (e) {
    closeMsg.clear();
    console.error("uploadFileToObjectStorage error", e);
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    });
    return;
  }
  saveMotif(saveData, close);
};

const handleEditFileCompleted = async (fileData, close) => {
  const { getClipedExportData, getClipedTimeInfoData, data } = fileData;
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  });
  let saveData = null;
  try {
    let clipedExportData = await getClipedExportData();
    let clipedTimeInfoData = getClipedTimeInfoData();
    if (clipedExportData.blob.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(
          new File([clipedExportData.blob], "output.wav", { type: "audio/wav" })
        );
        clipedExportData.url = transfile.blobUrl;
        clipedExportData.blob = transfile.blob;
        clipedExportData.file = transfile.file;
      } catch (e) {
        console.error("transFileToMp3 error", e);
      }
    }
    const fileSaveData = {
      url: clipedExportData.url,
      filename: data.filename,
      duration: clipedExportData.duration,
    };
    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      clipedExportData.file,
      (obj) => {
        renderData.uploadCallbackData = obj;
      }
    );
    // midi文件附加源文件数据和裁剪片段开始和结束数据
    let saveDataExtendData = {};
    if (tools.isMidiFile(renderData.fileTemp)) {
      const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
        renderData.fileTemp,
        (obj) => {
          renderData.uploadCallbackData = obj;
        }
      );
      saveDataExtendData = {
        midi_url: objectStorageRes.pathKey,
        extract_start_milliseconds: parseInt(clipedTimeInfoData.from * 1000),
        extract_end_milliseconds: parseInt(clipedTimeInfoData.to * 1000),
      };
    }
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(fileSaveData.duration * 1000),
      upload_link: null,
      // feed_id: draftDataStore.feed_id,
      title: fileSaveData.filename,
      source_type: 2,
      resource: null,
      ...saveDataExtendData,
    };
  } catch (e) {
    closeMsg.clear();
    console.error("uploadFileToObjectStorage error", e);
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    });
    return;
  }

  saveMotif(saveData, close);
};

const saveMotif = async (saveData, close) => {
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  });

  apiReferMusic
    .addMotifMusic(saveData)
    .then((res) => {
      closeMsg?.clear();
      if (res.code == 200 && res.data) {
        renderData.file = null;
        renderData.addLinkDialogVisible = false;
        emits("saveSuccess", res.data);
        close?.();
        renderData.clipSourceData = null;
      } else {
        if (res.code == 6308) {
          message.error({
            position: "top",
            content: $$t("create.motif_min_time_tip"),
          });
        } else if (res.code == 6353) {
          message.info({
            position: "top",
            content: $$t("create.generate_motif_audit_failed"),
          });
        } else if (res.code == 6320) {
          message.error({
            position: "top",
            content: $$t("create.song_cover_auditing_failed"),
          });
        } else if (res.code == 6316) {
          message.error({
            position: "top",
            content: $$t("create.song_title_audit_failed"),
          });
        } else {
          message.error({
            position: "top",
            content: $$t("create.save_failed"),
          });
        }
      }
    })
    .catch((err) => {
      closeMsg?.clear();
      console.error("addReferenceMusic error", err);
      message.error({
        position: "top",
        content: $$t("create.save_failed"),
      });
    });
};

onMounted(() => {
  nextTick(() => {
    initUploadContent();
  });
});
</script>
<style lang="scss">
.add-melody-file-container {
  position: relative;
  --filepond-height: 86px;
  .add-music-reference-edit-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .add-melody-file-main {
    height: var(--filepond-height);
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(148, 173, 255, 0.1);
    position: relative;
    &:hover {
      background: rgba(148, 173, 255, 0.2);
    }
    .add-melody-new-corner-mark {
      height: 32px;
      width: 32px;
      position: absolute;
      top: 0;
      right: 0;
      background: url("@/assets/img/new-corner-mark.png");
      background-size: 100% 100%;
      border-radius: 0 12px 0 0;
      overflow: hidden;
      span {
        position: absolute;
        font-family: HarmonyOS Sans SC;
        height: 20px;
        width: 44px;
        font-size: 9px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #4c2a87;
        transform: rotate(45deg);
      }
    }
  }
  .add-melody-file-desc {
    font-family: HarmonyOS Sans SC;
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    margin: 8px auto 0 auto;
    max-width: 250px;
  }
  .add-melody-file-selectfile {
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      height: 20px;
      width: 20px;
      min-width: 20px;
      background: url("@/assets/img/upload-white-ico.png") no-repeat center;
      background-size: 100% 100%;
    }
    span {
      margin-left: 4px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
    }
    label.vip_plan {
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      background: linear-gradient(
        110deg,
        #ffe08b 0%,
        #fff7d0 47%,
        #ffe08b 100%
      );
      padding: 0 3px;
      line-height: 14px;
      
      font-size: 8px;
      font-weight: 500;
      color: #3d2d00;
      margin: 0 0 0 8px;
    }
  }
  .filepond--root {
    height: var(--filepond-height) !important;
    min-height: var(--filepond-height) !important;
    background: transparent;
    box-shadow: none;
    border-radius: var(--filepond-height);
    align-items: center;
    justify-content: center;
    border-radius: var(--filepond-height);
    margin: 0;
    .filepond--wrapper {
      height: var(--filepond-height) !important;
      border-radius: var(--filepond-height);
    }
    .filepond--browser.filepond--browser {
      height: 0;
    }
    .filepond--list-scroller {
      display: none;
    }
    .filepond--credits {
      display: none;
    }

    .filepond--panel-root {
      border-radius: 0.5em;
      background: transparent;
      box-shadow: none;
      border-radius: var(--filepond-height);
      display: none;
    }

    .filepond--assistant {
      display: block;
    }
    .filepond--drop-label {
      display: block;
      visibility: visible !important;
      transform: translate3d(0px, 0, 0px) !important;
      height: var(--filepond-height) !important;
      border-radius: var(--filepond-height) !important;
      min-height: var(--filepond-height) !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      & > label {
        width: 0;
        height: 0;
        overflow: hidden;
        padding: 0;
      }
    }
    &[data-hopper-state="drag-over"] {
      .add-melody-file-main {
        border: 1px dashed #94adff;
      }
    }
  }

  &.add-melody-file-container--mobile {
    --filepond-height: 70px;
    .add-melody-file-main {
      padding: 0 0px;
      height: 70px;
      i {
        height: 16px;
        width: 16px;
        min-width: 16px;
      }
      span {
        font-size: 16px;
      }
      .vip_plan {
        margin: 0 0 0 4px;
      }
      .add-melody-file-desc {
        margin: 8px auto 0 auto;
        padding: 0 8px;
        font-size: 11px;
        max-width: 100%;
        min-height: unset;
      }
    }
  }
  &.add-melody-file-container--cn {
    --filepond-height: 56px;
    .add-melody-file-main {
      --filepond-height: 56px;
    }
    .add-melody-file-desc {
      display: none;
    }
    &.add-melody-file-container--mobile {
      --filepond-height: 56px;
      .add-melody-file-main {
        height: 56px;
        --filepond-height: 56px;
      }
    }
  }
}
</style>
